export default __webpack_public_path__ + "images/871a5164b1644202830e994fff026006-books_small.webp";